import { render, staticRenderFns } from "./StudentOnboardingModal.vue?vue&type=template&id=6849d465&scoped=true&"
import script from "./StudentOnboardingModal.vue?vue&type=script&lang=js&"
export * from "./StudentOnboardingModal.vue?vue&type=script&lang=js&"
import style0 from "./StudentOnboardingModal.vue?vue&type=style&index=0&id=6849d465&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6849d465",
  null
  
)

export default component.exports